<div class="workplace-chat-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="workplace-chat-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="workplace-chat-shell__sidebar"
    [class.workplace-chat-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.workplace-chat-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="workplace-chat-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="workplace-chat-page">
      <section class="workplace-chat-page__panel app-card">
        <div class="workplace-chat-page__panel-body">
          <div class="workplace-chat-page__workspace">
            <section class="workplace-chat-page__conversations">
              <div class="workplace-chat-page__panel-header workplace-chat-page__panel-header--conversations">
                <h2 class="workplace-chat-page__section-title">Chats</h2>

                <button
                  type="button"
                  class="workplace-chat-page__menu-button"
                  [attr.aria-label]="leftPanelMode === 'chats' ? 'Switch to users' : 'Switch to chats'"
                  [attr.title]="leftPanelMode === 'chats' ? 'Switch to users' : 'Switch to chats'"
                  (click)="toggleLeftPanelMode()"
                >
                  <span class="workplace-chat-page__menu-button-icon">+</span>
                </button>
              </div>

              <div class="workplace-chat-page__section-shell">
                <div class="workplace-chat-page__search-shell">
                  <span class="workplace-chat-page__search-icon" aria-hidden="true">⌕</span>
                  <input
                    type="text"
                    class="workplace-chat-page__search-input"
                    placeholder="Search"
                    readonly
                  />
                </div>

                <div class="workplace-chat-page__empty-state">
                  @if (leftPanelMode === 'chats') {
                    <div class="workplace-chat-page__empty-illustration" aria-hidden="true">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <h3>No Conversations Yet</h3>
                    <p>Start a new chat or invite others to join the conversation.</p>
                  } @else {
                    <div class="workplace-chat-page__empty-illustration" aria-hidden="true">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <h3>No Users Yet</h3>
                    <p>Your users list will appear here once the local chat service is connected.</p>
                  }
                </div>
              </div>
            </section>

            <section class="workplace-chat-page__thread">
              <div class="workplace-chat-page__thread-header">
                <div class="workplace-chat-page__thread-avatar">WC</div>
                <div class="workplace-chat-page__thread-meta">
                  <strong>Workplace Chat</strong>
                  <span>Local backend integration</span>
                </div>
              </div>

              <div class="workplace-chat-page__thread-body">
                <div class="workplace-chat-page__state workplace-chat-page__state--empty">
                  <p>{{ setupMessage }}</p>
                </div>
              </div>

              <div class="workplace-chat-page__composer">
                <input
                  type="text"
                  class="workplace-chat-page__composer-input"
                  placeholder="Type a message"
                  readonly
                />
                <button type="button" class="workplace-chat-page__composer-send" aria-label="Send message">
                  ➤
                </button>
              </div>
            </section>
          </div>
        </div>
      </section>
    </main>
  </div>
</div>
